export default "__VITE_ASSET__72452e00__"